import React from 'react';
import { useWindowSize } from 'react-use';
import { Text, Logo } from '@perch-labs/shrike';
import { Container } from 'styles';
import { screenIsSmall } from 'utils/screen-is-small';
import { copyFor } from 'config';

const getCopy = copyFor('notifications.currentPastModule.emptyState');

interface Props {
  tab: 'current' | 'past';
}

export const EmptyState = ({ tab }: Props) => {
  const { width } = useWindowSize();
  const copy = tab === 'current' ? getCopy('current') : getCopy('past');
  return (
    <Container
      flex
      justifyContent="center"
      padding={{ bottom: '64px', top: '64px' }}
    >
      <Container
        flex
        direction="column"
        alignItems="center"
        width="300px"
        textAlign="center"
      >
        <Logo
          type="node"
          variant="accent"
          scale={screenIsSmall(width) ? 4 : 5}
        />
        <Text
          tag="h2"
          textStyle="heading700"
          margin={{ bottom: '8px', top: '32px' }}
        >
          {copy.title}
        </Text>
        <Text textStyle="paragraph400">{copy.message}</Text>
      </Container>
    </Container>
  );
};
